import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Cell = styled.div`
  flex: 1 1 50%;
`;

const InfoList = ({items, style = {}, ...props}) => (
  <div style={{display: 'flex', flexWrap: 'wrap', ...style}} {...props}>
    {Object.entries(items).map(([k, v], i) => (
      <React.Fragment key={i}>
        <Cell>{k}</Cell>
        <Cell>{v}</Cell>
      </React.Fragment>
    ))}
  </div>
);

InfoList.propTypes = {
  items: PropTypes.object.isRequired,
  style: PropTypes.object,
};

export default InfoList;
